/******/
(() => { // webpackBootstrap
	var __webpack_exports__ = {};
	window.PXUTheme.jsCollection = {
		bindEvents: function ($section) {

			// Add settings from schema to current object
			window.PXUTheme.jsCollection = $.extend(this, window.PXUTheme.getSectionData($section));

			$('#tag_filter').off('change.jsCollection');
			if (this.enable_filter == true || this.enable_sorting == true) {
				$('#tag_filter').on('change.jsCollection', function () {
					window.PXUTheme.jsCollection.filterURL();
				});
			}

			$('body')
				.off('click.jsCollection')
				.on('click.jsCollection', '[data-option-filter]', function (e) {
					e.preventDefault();

					$(this).find('input').prop('checked', true);

					window.PXUTheme.jsCollection.multiTagFilter.init($(this));
					window.PXUTheme.scrollToTop($('.collection__content'));
				})
				.on('click.jsCollection', '[data-clear-filter]', function () {
					const $el = $(this).siblings('[data-option-filter]');
					const $productTagFilter = $('#tag_filter');

					$productTagFilter.find('option:eq(0)').prop('selected', true);
					window.PXUTheme.jsCollection.multiTagFilter.clearSelectedFilter($el);
					window.PXUTheme.scrollToTop($('.collection__content'));

				});

			this.syncSortSelect();
			this._ready = true;
		},
		init: function ($section) {

			this.bindEvents($section);

			// function to check if browser is IE
			var isIE11 = !!navigator.userAgent.match(/Trident.*rv:11\./);

			if (!this._featuresLoaded && !isIE11 && window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
				this._featuresLoaded = true;
				window.Shopify.loadFeatures([
					{
						name: 'shopify-xr',
						version: '1.0',
					},
					{
						name: 'model-viewer-ui',
						version: '1.0',
					}
				],)
			}

			// if (this.enable_sorting == true) {
			//   $('#sort-by').val($('#sort-by').data('default-sort'));
			// }

			if ($('[data-option-filter]').length) {
				// Show enabled filter tags based on selected checkboxes
				$('[data-tag-filter-checkbox]:checked').each(function () {
					window.PXUTheme.jsCollection.multiTagFilter.showSelectedFilter($(this));
				})
			}

			// If breadcrumbs enabled and basic pagination is set, call breadcrumbs object
			if (this.enable_breadcrumb && this.pagination_type == 'basic_pagination') {
				window.PXUTheme.breadcrumbs.init(this.number_of_pages);
			}
		},
		sortFromUrl: function (u) {
			const select = document.getElementById('sort-by');
			const sort = new URL(u, location.origin).searchParams.get('sort_by');
			return sort || (select && select.dataset.defaultSort) || '';
		},
		syncSortSelect: function (u) {
			const select = document.getElementById('sort-by');
			if (!select) return;

			const value = this.sortFromUrl(u || this._renderedUrl || location.href);
			const hasOption = Array.prototype.some.call(select.options, function (option) {
				return option.value === value;
			});
			if (hasOption) select.value = value;
		},
		resync: function () {
			const target = location.pathname + location.search;
			const inFlight = !!this._xhr && this._xhr.readyState > 0 && this._xhr.readyState < 4;
			const stuck = !inFlight && document.querySelector('.collection-matrix.loading-in-progress');

			if (target === this._renderedUrl && !stuck) {
				this.syncSortSelect();
				return;
			}

			this.syncSortSelect(target);
			this.updateView(target, { push: false });
		},
		filterURL: function () {

			var selectedOptions = [],
				query = '',
				currentTags = '',
				siteUrl = 'https://' + $.url('hostname');

			// check if language has been translated. Length equals one when default language (eg: '/') and greater than 1 when language is translated (eg: '/fr')
			
			var url1, url2, url3, path;
			if (window.PXUTheme.routes.root_url.length > 1) {
				url1 = $.url('1') ? '/' + $.url('1') + '/' : '';
				url2 = $.url('2') ? $.url('2') + '/' : '';
				url3 = $.url('3') ? $.url('3') + '/' : '';
				path = url1 + url2 + url3;
			} else {
				url1 = $.url('1') ? '/' + $.url('1') : '';
				url2 = $.url('2') ? '/' + $.url('2') : '';
				path = url1 + url2;
			}

			//Handle dropdowns if they exist
			if ($('#sort-by').length) {
				query = $('#sort-by').val();
			} else {
				query = $.url('?sort_by');
			}

			if ($('#tag_filter').length) {

				if ($('#tag_filter').data('default-collection') != $('#tag_filter').val()) {
					var urlTag = $('#tag_filter').val().substr($('#tag_filter').val().lastIndexOf('/') + 1);

					if (urlTag != 'all') {
						if ($.inArray(urlTag, selectedOptions) > -1) {
							//Do nothing
						} else {
							selectedOptions.unshift(urlTag);
						}
					}
				}
			}

			//Add all checkbox values to array
			$('[data-option-filter] input:checked').each(function () {
				selectedOptions.push($(this).val());
			});

			selectedOptions = $.makeArray(selectedOptions);
			if (selectedOptions.length > 0) {
				currentTags = '/';
			}
			//Loop through tags to create string to update page url
			$.each(selectedOptions, function (i, value) {

				if (i != selectedOptions.length - 1) {
					currentTags += selectedOptions[i] + '+';
				} else {
					currentTags += selectedOptions[i];
				}

			});

			window.PXUTheme.queryParameters.sort_by = query;
			delete window.PXUTheme.queryParameters.page;
			query = '?' + $.param(window.PXUTheme.queryParameters);

			this.processUrl(path, `${currentTags}`, query);
		},
		processUrl: function (path,  tags, query) {

			query = query.replace(/\page=(\w+)&/, '');
			var urlString = '';

			urlString = path + tags + query;
			this.updateView(urlString);
		},
		updateView: function (filterURL, options) {
			const self = window.PXUTheme.jsCollection;
			const push = !options || options.push !== false;

			if (self._xhr && self._xhr.readyState !== 4) {
				self._xhr.abort();
			}

			self._xhr = $.ajax({
				type: 'GET',
				url: filterURL,
				beforeSend: function () {
					$('.collection-matrix').addClass('fadeOut animated loading-in-progress');
					$('.collection-matrix__wrapper .collection__loading-icon').fadeIn();
				},
				success: function (data) {
				},
				error: function (x, t, m) {
					if (t === 'abort') return;
					console.log(x);
					console.log(t);
					console.log(m);
					location.replace(location.protocol + '//' + location.host + filterURL);

				},
				dataType: "html"
			});

			self._xhr.then(function (data) {

				const $breadcrumbContainer = $('.breadcrumb__container');
				const $collectionMatrix = $('.collection-matrix');
				const $collectionMain = $('[data-collection-main]');

				const filteredData = $(data).find('.collection-matrix__wrapper');
				const filteredPageLinks = $(data).find('.container--pagination');
				const noProducts = $(data).find('.container--no-products-in-collection');

				if (!filteredData.length && !noProducts.length) {
					location.assign(filterURL);
					return;
				}

				// Get and set new breadcrumb html
				const filteredBreadcrumb = $(data).find('.breadcrumb__container').html();
				$breadcrumbContainer.html(filteredBreadcrumb);

				// Remove loading animation
				$collectionMatrix.removeClass('fadeIn animated loading-in-progress');

				if (filteredData.length) {
					// Add products to container
					$collectionMain.empty();
					$collectionMain.append(filteredData);
				} else {
					// Display no product message
					$collectionMain.empty();
					$collectionMain.append(noProducts);
				}

				$collectionMain.append(filteredPageLinks);

				if (window.LazyLoader && typeof window.LazyLoader.refresh === 'function') {
					window.LazyLoader.refresh($collectionMain[0]);
				}

				if (push) {
					window.history && window.history.pushState && window.history.pushState("", "", filterURL);
				}

				const rendered = new URL(filterURL, location.origin);
				self._renderedUrl = rendered.pathname + rendered.search;
				self.syncSortSelect();

				window.PXUTheme.infiniteScroll.init();

			});
		},
		multiTagFilter: {
			init: function ($el) {

				// Show filter and hide siblings
				this.showSelectedFilter($el);

				// Update url
				window.PXUTheme.jsCollection.filterURL();

				var urlIndex;
				if (window.PXUTheme.routes.root_url.length > 1) {
					urlIndex = 3
				} else {
					urlIndex = 2
				}

				// Hide filters if types or vendors is in URL (can't be combined)
				if ($.url(urlIndex) === 'types' || $.url(urlIndex) === 'vendors') {
					$('.block__tag-filter').remove();
				}

			},
			showSelectedFilter: function ($el) {
				const $sidebarToggleBlock = $el.parents('.sidebar-toggle-active');
				const $filterItem = $el.parents('.tag-filter__item');

				$filterItem.addClass('is-active');
				$filterItem.siblings(':not(.is-active)').addClass('is-hidden');
				$filterItem.find('[data-clear-filter]').removeClass('is-hidden');

				// If sidebar toggle is enabled, show filter in sidebar content
				if ($sidebarToggleBlock.length) {
					let $toggleBtn = $sidebarToggleBlock.find('[data-sidebar-block__toggle="closed"]');

					window.PXUTheme.jsSidebar.openSidebarBlock($toggleBtn);
				}

			},
			clearSelectedFilter: function ($el) {

				const $filterItem = $el.parents('.tag-filter__item');

				$filterItem.removeClass('is-active')
					.find('input').prop("checked", false);
				$filterItem.siblings()
					.removeClass('is-hidden');
				$filterItem.find('[data-clear-filter]')
					.addClass('is-hidden');

				//Update url
				window.PXUTheme.jsCollection.filterURL();
			}
		},
		unload: function ($section) {
			$('#tag_filter, #sort-by').off();
			$('[data-option-filter]').off();
			$('[data-reset-filters]').off();
			$('[data-clear-filter]').off();
			$('body').off('.jsCollection');
			if (this._xhr && this._xhr.readyState !== 4) {
				this._xhr.abort();
			}
			this._ready = false;
			window.PXUTheme.breadcrumbs.unload();
		}
	}

	const jsCollection = window.PXUTheme.jsCollection;
	jsCollection._renderedUrl = location.pathname + location.search;

	if (!window.PXUTheme.__collectionSortListeners) {
		window.PXUTheme.__collectionSortListeners = true;

		document.addEventListener('change', function (e) {
			if (!e.target || e.target.id !== 'sort-by') return;

			const collection = window.PXUTheme.jsCollection;
			if (collection && collection._ready) {
				collection.filterURL();
				return;
			}

			const url = new URL(location.href);
			url.searchParams.set('sort_by', e.target.value);
			url.searchParams.delete('page');
			location.assign(url.pathname + url.search);
		});

		window.addEventListener('popstate', function () {
			const collection = window.PXUTheme.jsCollection;
			if (!collection) return;

			if (collection._ready) {
				collection.resync();
			} else if (location.pathname + location.search !== collection._renderedUrl) {
				location.reload();
			}
		});

		window.addEventListener('pageshow', function (e) {
			const collection = window.PXUTheme.jsCollection;
			if (!e.persisted || !collection) return;

			collection.syncSortSelect();
			if (collection._ready) collection.resync();
		});
	}

	const select = document.getElementById("sort-by");
	if (select) {
		const wrapper = select.closest(".select");

		select.addEventListener("mousedown", () => {
			wrapper.classList.toggle("is-open");
		});

		select.addEventListener("blur", () => {
			wrapper.classList.remove("is-open");
		});
	}
})();